import { useEffect, useState } from 'react';
import { Radio, RadioGroup } from '../Ant';
import { Flex } from 'antd';
import { getFormatedOrganisationList } from '../../constants/utilityFunctions';
import { getRunningTimersForCurrentOrg } from '../../hooks/useTimerActions';
import { useUser } from '../../context/UserContext';
import { ITimer } from '../../interface/timer';
import OrganisationRadioCard from '../common/organisationRadioCard';
import SwitchOrganisationConfirmModal from './switchOrganisationConfirmModal';

interface PendingOrganisationSwitch {
  organisation: IOrganisation;
  runningTimers: ITimer[];
}

const OrganisationList = ({
  organisationList,
  setSelectOrganisation,
  selectOrganisation,
  handleSelectOrganisation,
}: {
  organisationList: IOrganisation[];
  setSelectOrganisation: (value: IOrganisation) => void;
  selectOrganisation?: IOrganisation;
  handleSelectOrganisation: (organisation: IOrganisation) => void;
}) => {
  const { user } = useUser();
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [pendingSwitch, setPendingSwitch] = useState<PendingOrganisationSwitch | null>(null);

  useEffect(() => {
    if (selectOrganisation) {
      setSelectedValue(selectOrganisation.organizationName);
    }
  }, [selectOrganisation]);
  const formattedList = getFormatedOrganisationList(organisationList);

  const applyOrganisationSwitch = (organisation: IOrganisation) => {
    setSelectOrganisation(organisation);
    handleSelectOrganisation(organisation);
  };

  const requestOrganisationSwitch = (organisation: IOrganisation) => {
    const runningTimers = getRunningTimersForCurrentOrg(user?.id ?? '');
    if (runningTimers.length === 0) {
      applyOrganisationSwitch(organisation);
      return;
    }
    setPendingSwitch({ organisation, runningTimers });
  };

  const handleOrganisationChange = (organizationName: string) => {
    const selectedOrganisation = formattedList.find(
      (item) => item.organizationName === organizationName,
    );
    if (!selectedOrganisation) {
      return;
    }
    setSelectedValue(organizationName);
    requestOrganisationSwitch(selectedOrganisation);
  };

  const dismissSwitchConfirmation = () => {
    setPendingSwitch(null);
    setSelectedValue(selectOrganisation?.organizationName ?? null);
  };

  const confirmOrganisationSwitch = () => {
    if (!pendingSwitch) {
      return;
    }
    setPendingSwitch(null);
    applyOrganisationSwitch(pendingSwitch.organisation);
  };

  return (
    <Flex vertical gap={15} className="resizable-modal-fill">
      <RadioGroup
        value={selectedValue}
        data-testid="organisation-selection-radio-group"
        onChange={(e) => handleOrganisationChange(e.target.value as string)}
        className="d-flex fd-column gap-10 overflow-y-auto settings-ogranisation-selection scroll-to-modal-edge resizable-modal-scroll"
      >
        {formattedList.map((item) => (
          <Radio
            data-testid={`organisation-radio-${item?.organizationName}`}
            key={item.organizationId}
            value={item.organizationName}
            disabled={item.disabled}
          >
            <OrganisationRadioCard organisation={item} />
          </Radio>
        ))}
      </RadioGroup>

      <SwitchOrganisationConfirmModal
        open={pendingSwitch !== null}
        targetOrganisationName={pendingSwitch?.organisation.organizationName ?? ''}
        runningTimers={pendingSwitch?.runningTimers ?? []}
        onCancel={dismissSwitchConfirmation}
        onConfirm={confirmOrganisationSwitch}
      />
    </Flex>
  );
};

export default OrganisationList;
